export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/ACRTiffToJPEGWorker.648c49b9.worker.js");
}
